import { type CSSProperties, type HTMLAttributes, type Ref } from 'react';
import clsx from 'clsx';
import './Spinner.css';

export type SpinnerTone = 'primary' | 'accent' | 'danger' | 'info' | 'neutral';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  /** Diameter in px. Default 24. */
  size?: number;
  tone?: SpinnerTone;
  /** Describe what's loading for screen readers. */
  label?: string;
  ref?: Ref<HTMLSpanElement>;
}

/**
 * Spinner — circle with a quarter-arc that rotates. Color inherits
 * from tone tokens. Respects `prefers-reduced-motion` (slows to 2.5s).
 */
export function Spinner({ size = 24, tone = 'primary', label, className, style, ref, ...rest }: SpinnerProps) {
  const wrapperStyle: CSSProperties = { ...style, width: size, height: size };
  return (
    <span
      ref={ref}
      className={clsx('fluent-spinner', className)}
      data-tone={tone}
      style={wrapperStyle}
      role="status"
      aria-label={label ?? 'იტვირთება'}
      {...rest}
    >
      <svg viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path
          d="M22 12a10 10 0 0 1-10 10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </span>
  );
}
